import { render, staticRenderFns } from "./bank-list.vue?vue&type=template&id=dc553a4c&scoped=true&"
import script from "./bank-list.vue?vue&type=script&lang=js&"
export * from "./bank-list.vue?vue&type=script&lang=js&"
import style0 from "./bank-list.vue?vue&type=style&index=0&id=dc553a4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../kuaishou-frontend-collect/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc553a4c",
  null
  
)

export default component.exports